import { CotizacionData } from '../types/cotizacionFormTypes';

interface ComboComponent {
  sku: string;
  price: number;
  tax_rate: number;
  name: string;
}

export interface TransformedCotizacionData {
  billing: {
    address_1: string;
    address_2: string;
    city: string;
    company: string;
    country: string;
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    postcode: string;
    second_last_name: string;
    second_name: string;
    state: string;
  };
  shipping: {
    address_1: string;
    address_2: string;
    city: string;
    company: string;
    country: string;
    first_name: string;
    last_name: string;
    phone: string;
    postcode: string;
    second_last_name: string;
    second_name: string;
    state: string;
  };
  line_items: Array<{
    product_id: string;
    quantity: number;
    price: number;
    tax_rate: string;
    name: string;
    sku: string;
    total: number;
    discount: number;
    meta_data: Array<{
      key: string;
      value: string;
    }>;
    custom_kit_products?: Array<{
      sku: string;
      precio: string;
      iva: number; // Porcentaje de IVA como entero (ej: 19)
      name: string;
    }>;
  }>;
  meta_data: Array<{
    key: string;
    value: string;
  }>;
  status?: string;
  payment_method: string;
  payment_method_title: string;
  total: string;
  shipping_total: string;
  currency: string;
  store_name: string;
  guia: string;
  date_created: string;
  date_modified: string;
  id?: string;
}

export const transformCotizacionData = (formData: CotizacionData): TransformedCotizacionData => {
  return {
    billing: {
      address_1: formData.billingAddress?.address_1 || '',
      address_2: '',
      city: formData.billingAddress?.city || '',
      company: '',
      country: 'CO',
      email: formData.customer?.email || '',
      first_name: formData.customer?.first_name || '',
      last_name: formData.customer?.last_name || '',
      phone: formData.shippingAddress?.phone || '',
      postcode: '',
      second_last_name: '',
      second_name: '',
      state: formData.billingAddress?.state || ''
    },
    shipping: {
      address_1: formData.shippingAddress?.address_1 || '',
      address_2: '',
      city: formData.shippingAddress?.city || '',
      company: '',
      country: 'CO',
      first_name: formData.customer?.first_name || '',
      last_name: formData.customer?.last_name || '',
      phone: formData.shippingAddress?.phone || '',
      postcode: '',
      second_last_name: '',
      second_name: '',
      state: formData.shippingAddress?.state || ''
    },
    line_items: formData.line_items?.map((item: any) => {
      const productDetail = formData.productDetails?.[item.product_id];
      const taxRate = productDetail?.tax_rate?.toString() || '0.19';
      const isCombo = productDetail?.is_combo === 1;
      
      const lineItem: any = {
        product_id: item.product_id,
        sku: productDetail?.sku || item.sku || '',
        name: item.product_name || productDetail?.name || '',
        quantity: Number(item.quantity),
        price: Number(item.price),
        tax_rate: taxRate,
        discount: Number(item.discount || 0),
        total: Number(item.price) * Number(item.quantity) - Number(item.discount || 0),
        meta_data: [
          {
            key: 'product_iva',
            value: taxRate
          }
        ]
      };

      // Si es un combo, agregar los componentes
      if (isCombo && productDetail?.components) {
        lineItem.custom_kit_products = productDetail.components.map((component: ComboComponent) => ({
          sku: component.sku,
          precio: component.price.toString(),
          iva: Math.round(Number(component.tax_rate) * 100), // Convertir a porcentaje entero (ej: 0.19 -> 19)
          name: component.name
        }));
        
        console.log('Componentes de combo agregados (cotización):', lineItem.custom_kit_products);
      }

      return lineItem;
    }) || [],
    meta_data: [
      { key: 'cotizacion_agente', value: formData.agente?.toString() || ''},
      {  key: 'tipo_lead',  value: formData.extraDetails?.tipo_lead || ''},
      {  key: 'tipo_cliente',  value: formData.extraDetails?.tipo_cliente || ''},
      {  key: 'marca',  value: formData.extraDetails?.marca || ''},
      {  key: 'banco',  value: formData.extraDetails?.banco || ''},
      {  key: 'transportadora',  value: formData.extraDetails?.transportadora || ''},
      {  key: 'conocer',  value: formData.extraDetails?.conocer || ''},
      {  key: 'id_pago',  value: formData.extraDetails?.id_pago || ''},
      {  key: 'forma_pago',  value: formData.extraDetails?.forma_pago || ''},
      {  key: 'payment_method',  value: formData.extraDetails?.payment_method || ''},
      {  key: 'transaction_id',  value: formData.extraDetails?.transaction_id || ''},
      {  key: 'destino_cotizacion',  value: formData.extraDetails?.destino_cotizacion || ''},
      {  key: 'ciudad_origen',  value: formData.billingAddress?.city || '',},
      {  key: 'ciudad_destino',  value: formData.shippingAddress?.city || '',},
      {  key: 'store_name',  value: formData.store_name || ''},
      {  key: 'costo_envio',  value: formData.status === 'guiaeliminada' ? '' : formData.extraDetails?.costo_envio || '0'},
      {  key: 'billing_cedula',  value: formData.customer?.documento || ''},
      {  key: 'customer_note',  value: formData.extraDetails?.customer_note || ''}
    ],
    status: formData.status || 'pending',
    payment_method: formData.extraDetails?.payment_method || 'cod',
    payment_method_title: 'Pago en efectivo - Contra entrega',
    total: formData.total || '0',
    shipping_total: formData.status === 'guiaeliminada' ? '' : formData.extraDetails?.costo_envio || '0',
    store_name: formData.store_name || '',
    currency: 'COP',
    guia: formData.status === 'guiaeliminada' ? '' : formData.guia || '',
    date_created: formData.date_created || '',
    date_modified: formData.date_modified || '',
    ...(formData.id ? { id: formData.id.toString() } : {})
  };
}; 